// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__N7uwG","insightsList":"newBusinessInsightsMenu_insightsList__4vk3r","active":"newBusinessInsightsMenu_active__2jkcV"};